var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgIconLanguageGerman = function SvgIconLanguageGerman(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 80 80"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_language_german_svg__a",
    x1: "100%",
    x2: "0%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2CBFC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#46EEAA"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "url(#icon_language_german_svg__a)",
    rx: 13
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M32.676 56v-4.65c-1.707 3.475-4.395 5.212-8.064 5.212-2.965 0-5.293-1.086-6.985-3.257-1.692-2.172-2.538-5.159-2.538-8.962 0-4.133.954-7.427 2.864-9.883 1.909-2.456 4.473-3.684 7.693-3.684 2.575 0 4.918 1.019 7.03 3.055V20.534h6.67V56h-6.67zm0-18.216c-1.602-1.797-3.317-2.695-5.144-2.695-1.632 0-2.935.786-3.908 2.358-.973 1.573-1.46 3.684-1.46 6.334 0 5.046 1.617 7.57 4.852 7.57 1.976 0 3.863-1.266 5.66-3.796v-9.77zM67.715 55.17c-3.16.928-6.154 1.393-8.985 1.393-4.117 0-7.367-1.168-9.748-3.504-2.38-2.336-3.57-5.526-3.57-9.569 0-3.818 1.088-6.891 3.267-9.22 2.179-2.328 5.058-3.493 8.636-3.493 3.61 0 6.245 1.138 7.907 3.414 1.662 2.276 2.493 5.878 2.493 10.804H52.419c.45 4.702 3.032 7.053 7.749 7.053 2.231 0 4.747-.517 7.547-1.55v4.672zM52.329 41.243h8.85c0-4.208-1.355-6.311-4.066-6.311-2.755 0-4.35 2.103-4.784 6.311z"
  }))));
};
export default SvgIconLanguageGerman;